var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ValidationErrorAtom', [_vm._v(" " + _vm._s(_vm.$t("validationErrors.".concat(_vm.validationError.type), _vm.validationError)) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }